module.exports = {"610826100":"名州镇","610826101":"薛家峁镇","610826102":"崔家湾镇","610826103":"定仙墕镇","610826104":"枣林坪镇","610826105":"义合镇","610826106":"吉镇","610826107":"薛家河镇","610826108":"四十里铺镇","610826109":"石家湾镇","610826110":"田庄镇","610826111":"中角镇","610826112":"满堂川镇","610826113":"张家砭镇","610826114":"白家硷镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610826.json
// module id = 3004
// module chunks = 0